import { Link } from "react-router-dom";
import { Reveal } from "@/components/motion";

export default function Hero() {
  return (
    <section className="relative bg-ink min-h-screen flex flex-col justify-center overflow-hidden" data-testid="hero">
      {/* subtle animated gold line + faint geometry */}
      <div
        className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold to-transparent animate-gold-drift pointer-events-none"
        aria-hidden="true"
      />
      <div className="absolute -right-40 top-1/2 -translate-y-1/2 w-[640px] h-[640px] rounded-full border border-white/[0.04] pointer-events-none" aria-hidden="true" />
      <div className="absolute -right-24 top-1/2 -translate-y-1/2 w-[420px] h-[420px] rounded-full border border-gold/[0.07] pointer-events-none" aria-hidden="true" />
      <img src="/brand/mark-white.png" alt="" aria-hidden="true" className="hidden lg:block absolute right-[-9px] top-1/2 -translate-y-1/2 w-[210px] opacity-[0.06] pointer-events-none" />

      <div className="wrap relative pt-36 pb-24 lg:pt-40">
        <Reveal>
          <p className="eyebrow text-gold flex items-center gap-3 mb-8">
            ESG &amp; Sustainability Advisory <span className="hidden sm:block h-px w-14 bg-gold/60" />
          </p>
        </Reveal>

        <h1 className="h-display font-bold text-white text-[42px] leading-[1.05] sm:text-[64px] lg:text-[84px] max-w-4xl" data-testid="hero-headline">
          <Reveal delay={0.1}>Sustainability is</Reveal>
          <Reveal delay={0.2}>a business decision.</Reveal>
        </h1>

        <Reveal delay={0.3}>
          <p className="mt-8 text-mute text-[16px] sm:text-lg leading-relaxed max-w-xl" data-testid="hero-subcopy">
            SarvaRitam helps organisations navigate ESG and sustainability, climate and responsible investment with
            clarity, evidence and practical action.
          </p>
        </Reveal>

        <Reveal delay={0.4}>
          <div className="mt-11 flex flex-col sm:flex-row gap-4">
            <Link to="/contact" className="btn-gold px-8 py-4 justify-center" data-testid="hero-primary-cta">
              Book a Consultation
            </Link>
            <Link to="/services" className="btn-outline-white px-8 py-4 justify-center" data-testid="hero-secondary-cta">
              Explore Services
            </Link>
          </div>
        </Reveal>
      </div>

      <div className="wrap relative pb-10 hidden lg:block">
        <p className="font-mono text-[10px] uppercase tracking-widest2 text-white/55">Measure · Understand · Transform</p>
      </div>
    </section>
  );
}
